import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import { deviceTypes } from '../../../../shared/enums/deviceTypes';
import UserDetails from './userDetails/UserDetails';
import useClickOutside from '../../../../shared/hooks/useClickOutside';
import circle from '../../../../assests/circle.png';
import Popup from '../../../../shared/components/ui/popup/Popup';
import classes from './UserProfile.module.css';
import Icon from '../../../../shared/components/ui/icons/Icon';
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import { login } from '../../../../shared/store/redux/auth-actions';

const UserProfile = () => {

    const userDetailsRef = useRef();
    const [openUserDetails, setOpenUserDetails] = useState();
    const { deviceType } = useSelector(state => state.responsive);
    const { texts } = useSelector(state => state.translate);
    const isAuth = useSelector(state => state.auth.isAuth);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();

    useClickOutside(userDetailsRef, () => {
        if (deviceType !== deviceTypes.mobile) {
            setOpenUserDetails(false);
        }
    });

    return (
        <div className={classes.UserProfile} ref={userDetailsRef}>
            {isAuth ?
                <div>
                    <AccessibilityClickableDiv src={circle} className={classes.UserDetails} onClick={setOpenUserDetails} >
                        {`${user?.given_name?.charAt(0)}.${user?.family_name?.charAt(0)}`}
                    </AccessibilityClickableDiv>
                </div>
                :
                <Icon className={classes.UserIcon} size="36px" name={iconsList.profile} onClick={() => dispatch(login())} />
            }

            {openUserDetails && <>
                {deviceType !== deviceTypes.mobile ?
                    <UserDetails close={() => setOpenUserDetails(false)} />
                    :
                    <Popup
                        close={() => setOpenUserDetails(false)}
                        title={texts.myProfil}
                        icon={iconsList.profilePurple}
                        dropClass={classes.UserProfilePopup}
                    >
                        <UserDetails />
                    </Popup>
                }
            </>}
        </div>
    );
};

export default UserProfile;